import { IAjaxConfig } from '../libraries';
export class EnumApiXiaozhi {
  /**
   * @dec 小智记录埋点
   * @method post
   */
  readonly lcicsp_router_record: IAjaxConfig = {
    url: '/api/scgateway/chat/router/record',
    method: 'post',
    interceptErrMsg: true,
  };
  /**
   * @dec 获取用户token
   */
  readonly admin_user: IAjaxConfig = {
    url: '/api/scgateway/iam/login/getUserToken',
    method: 'post',
    interceptErrMsg: true,
  };
  /**
   * @dec 校验用户token
   */
  readonly check_token: IAjaxConfig = {
    url: '/api/scgateway/iam/check/token',
    method: 'post',
    interceptErrMsg: true,
  };
}
